import {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {PreviewIndicatorContent} from "./preview";
import {Tooltip} from "../Tooltip";

export const PreviewIndicator = ({indicatorId}) => {
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);

    function handleShow() {
        setFullscreen(true);
        setShow(true);
    }

    return (
        <>
            <Tooltip label="Visualizar indicador">
                <Button className="btn-sm" onClick={() => handleShow()}>
                    <i className="bi bi-eye"/>
                </Button>
            </Tooltip>

            <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
                <Modal.Header closeButton className="bg-primary border-0">
                    <Modal.Title>Indicador</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {show && <PreviewIndicatorContent indicatorId={indicatorId} />}
                </Modal.Body>
            </Modal>
        </>
    );
}

